module.exports = __webpack_public_path__ + "media/images/front/icon_sumi-0f014a914fd608b17c5c744c563b73ee.png";